import Text from '../Text';
import Game from '../../Game';
import AnimationComponent from '../../Component/Animation';
import Point from '../../Utility/Point';

export default class RewardTextEffect extends Text {
    public onCreate(params: any): void {
        super.onCreate({
            style: Game.style.getStyle('reward.text'),
            anchor: new Point(0.5, 0.5),
            ...params,
        });

        this.addComponent(AnimationComponent, {
            playOnStart: true,
            clipName: 'ScoreTextPopIn',
            ...params,
        });
    }
}
